import { LuTreeDeciduous } from 'react-icons/lu'

const PlanterTimeline = () => {
  const timeline = [
    {
      label: 'Submit Tree Request'
    },
    {
      label: 'Under review'
    },
    { label: 'Approved', date: 'or Withdrawn/Declined' },
    { label: 'Quote and payment', date: 'via email' },
    {
      label: 'Confirm planting'
    },
    { label: 'Add monitoring', date: 'Years 1–3' }
  ]

  return (
    <div className='w-full py-2 min-w-[730px]'>
      <div className='flex justify-between items-start relative'>
        {timeline.map((item, index) => (
          <div
            key={index}
            className='flex flex-col items-center text-center relative w-full'
          >
            {index > 0 && (
              <div className='absolute top-2 left-0 w-1/2 h-0.5 bg-gray-300 z-0' />
            )}
            {index < timeline.length - 1 && (
              <div className='absolute top-2 right-0 w-1/2 h-0.5 bg-gray-300 z-0' />
            )}
            <div className='w-6 h-6 bg-secondaryDark rounded-full z-10 mb-1 flex items-center justify-center'>
              <LuTreeDeciduous className='text-white w-4 h-4' />
            </div>
            <div className='text-sm font-medium text-gray-800'>
              {item.label}
            </div>
            {item.date ? (
              <div className='text-xs text-gray-500'>{item.date}</div>
            ) : (
              <div className='h-4' />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default PlanterTimeline
